import React, { useCallback, useEffect, useState } from 'react'
import TopSection from '../../LT/TopSection'
import DataDetails from './DataDetails';
import { useDispatch } from 'react-redux';
import { getTicketSummaryData } from '../../../redux/actions/SupportTicket/TicketSummary';
import { toast } from 'react-toastify';
import { Loader } from '../../../components/common/Loader';

const TicketSummary = () => {
  const dispatch = useDispatch()
  const [isLoading, setIsLoading] = useState(false);
  const [summaryData, setSummaryData] = useState([]);

  const pagination = true;
  const paginationPageSize = 50;
  const paginationPageSizeSelector = [50, 100, 200, 500];

  const getAllSummaryData = useCallback(async () => {
    setIsLoading(true);
    try {
      const response = await dispatch(
        getTicketSummaryData()
      );
      if (response.meta.requestStatus === "fulfilled") {
          setSummaryData(response?.payload);
      } else {
        setIsLoading(false)
        toast.error(response.payload, {
          autoClose: 2000,
        });
      }
    } catch (error) {
      console.error("Error", error);
    } finally {
      setIsLoading(false);
    }
  }, [dispatch]);

 useEffect(() => {
    getAllSummaryData();
 }, [getAllSummaryData])

  return (
    <>
      <TopSection
        labelList={[
          { title: "Home", path: "/landing-page" },
          { title: "Ticket Summary" },
        ]}
        hideHeader={true}
        headerName={"Ticket Summary"}
      />
      <div>
        { isLoading ? 
        <Loader />
        :
        <DataDetails 
            row={summaryData}
            pagination= {pagination}
            paginationPageSize={paginationPageSize}
            paginationPageSizeSelector={paginationPageSizeSelector}
        />
        }
      </div>
    </>
  );
};

export default TicketSummary